// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CWBsS","selected":"styles_selected__1VyP3"};